import { useEffect, useRef, useState } from 'react';
import { withErrorBoundary } from 'react-error-boundary';

function CookieInformation(props: { locale?: string }) {
    const { locale } = props;
    if (!locale) return;

    const language = locale.split('-')[0];
    if (!language) return null;

    const wrapper = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const script = document.createElement('script');
        script.id = 'CookiePolicy';
        script.src = 'https://policy.app.cookieinformation.com/cid.js';
        script.type = 'text/javascript';
        script.setAttribute('data-culture', language);

        wrapper.current?.appendChild(script);
    }, [language]);

    return <div ref={wrapper} />;
}

export default withErrorBoundary(CookieInformation, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
